import React, { useState } from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';
import { useAuth } from '@/contexts/AuthContext';
import { useMovimentacaoMutations } from '../../../hooks/data';
import ExcluirMovimentacaoModal, { type ExcluirMovimentacaoConfirmacao } from './ExcluirMovimentacaoModal';

interface ExcluirMovimentacaoButtonProps {
  solicitacaoId: string;
  movimentacaoId: string;
  descricaoMovimentacao: string;
}

/** Lixeira no cabeçalho do MovimentacaoCard + modal de motivo — separado do card pra
 * não inchar ainda mais aquele arquivo. Quem decide se aparece é o card (só SI, e só
 * antes de 'entregue' — ver movimentacaoService.excluir). */
export default function ExcluirMovimentacaoButton({
  solicitacaoId,
  movimentacaoId,
  descricaoMovimentacao,
}: ExcluirMovimentacaoButtonProps) {
  const { user } = useAuth();
  const { excluirMovimentacao } = useMovimentacaoMutations(solicitacaoId);
  const [aberto, setAberto] = useState(false);

  const handleConfirmar = ({ motivoExclusaoTipo, motivoExclusao }: ExcluirMovimentacaoConfirmacao) => {
    if (!user) return;
    excluirMovimentacao.mutate(
      {
        id: movimentacaoId,
        motivoExclusaoTipo,
        motivoExclusao,
        excludedBy: { id: user.collaboratorId ?? user.uid, name: user.displayName ?? user.email ?? '', avatar: null },
      },
      { onSuccess: () => setAberto(false) }
    );
  };

  return (
    <>
      <button
        type="button"
        className="shrink-0 text-gray-400 hover:text-red-600"
        onClick={() => setAberto(true)}
        title="Excluir Movimentação"
      >
        <TrashIcon className="h-4 w-4" />
      </button>
      <ExcluirMovimentacaoModal
        isOpen={aberto}
        onClose={() => setAberto(false)}
        descricaoMovimentacao={descricaoMovimentacao}
        onConfirmar={handleConfirmar}
        confirmando={excluirMovimentacao.isPending}
      />
    </>
  );
}
